export default __webpack_public_path__ + "static/media/Dashboard-Stats-min.660107fb.png";